export default __webpack_public_path__ + "static/media/PowerPoleWallDouble_MK3.256.e659753e.png";